import {Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ShareWrapper } from './share-wrapper.component';
import { JoiResource } from 'globals/store/resources.data';
import { CustomQuestion } from 'globals/store/events.data';
import { JoiTemplate } from 'globals/store/publish.data';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { SocialLinksComponent } from 'src/app/components/social-links/social-links.component';
import { CustomQuestionsComponent } from 'src/app/components/entities/custom-questions.component';
import { ResourceContactListComponent } from '../resources/resource-contact-list.component';
import { ImageUploaderComponent } from 'src/app/components/wrappers/image-uploader.component';
import { MatButtonModule } from '@angular/material/button';
import { Subject } from 'rxjs';

@Component({
    selector: 'share-edit-resource-form',
    template: `
<div class="event-name">{{ topTitle }}</div>
<div class="instructions" *ngIf="!!instructions" [innerHTML]="instructions"></div>
<div class="top">
  <div class="photos">
    <image-uploader
      #logoEditor
      [id]="resource?.id || ''"
      [publishCode]="publishCode"
      [public]="true"
      [immediate]="true" 
      [isLogo]="true"
      [thumbUrl]="resource.logoUrl" 
      [photoUrl]="resource.fullLogoUrl"
      [eventId]="eventId"
      [hints]="imageHints"
      [saveName]="resource.name"
      [type]="'resource'" 
      [subtype]="'logo'" 
      [placeholder]="'Add logo'" 
      [uploadText]="'UPLOAD LOGO'"
    ></image-uploader>
  </div>
  <div class="fields">
    <mutating-input [object]="resource" [prop]="'name'" [placeholder]="'Resource name'"></mutating-input>
    <add-manage-wrapper class="social-open" [hideHRule]="true" wrapperTitle="SOCIAL" [openLabel]="!resource.social?.length ? '+ ADD A SOCIAL LINK' : 'MANAGE SOCIAL LINKS'" (open)="openSocialLinks($event, resource)">
      <social-links *ngIf="resource?.social?.length" [socialLinks]="resource.social || []"></social-links>
    </add-manage-wrapper>
  </div>
</div>
<div class="bottom">
  <input-editor 
    class="placeholder-no-italics"
    [object]="resource" 
    [forceSave]="forceSave" 
    [prop]="'about'" 
    [placeholder]="'About resource'"
  ></input-editor>
  <resource-contact-list *ngIf="resource" [resource]="resource" [public]="true" [eventId]="eventId" [publishCode]="publishCode" [template]="template"></resource-contact-list>
  <custom-questions
    [entity]="resource"
    [questions]="customQuestions"
    [showMandatoryWarnings]="showMandatoryWarnings"
    [shareView]="true"
    (updateQuestion)="updateCustomQuestion($event, resource)"
  ></custom-questions>
  <button mat-button color="primary" (click)="submit()" [disabled]="processing || logoEditor.imageChanging">
    <div class="button_content">
      Submit
      <loader icon="button_wheel"></loader>
    </div>
  </button>
  <div class="error-holder" *ngIf="error" [innerHTML]="helpers.strWithBreak(error)"></div>
</div>
`,
    styleUrls: ['./share.editPerformer.scss'],
    styles: [`
::ng-deep resource-contact-list resource-contact-card { max-width: unset !important; }
::ng-deep resource-contact-list .label { margin: 10px 0 20px; }
    `],
    standalone: true,
    imports: [CommonModule, MatButtonModule, ImageUploaderComponent, ResourceContactListComponent, CustomQuestionsComponent,  SocialLinksComponent, LoaderComponent, InputEditorComponent, AddManageWrapperComponent, MutatingInputComponent, ],

})
export class ShareResourceFormComponent extends ShareWrapper<ShareResourceFormComponent> {
    @Input() publishCode:string
    @Input() loading:boolean
    @Input() processing:boolean
    @Input() customQuestions: CustomQuestion[] = []
    @Input() callToSubmit: boolean
    @Input() topTitle: string
    @Input() resource: JoiResource
    @Input() eventId: string
    @Input() error
    @Input() instructions: string
    @Input() template: JoiTemplate
    showMandatoryWarnings = false;
    forceSave: Subject<void> = new Subject<void>(); 

    @ViewChild('logoEditor') logoEditor
    @Output() onSubmit: EventEmitter<JoiResource> = new EventEmitter()

    async submit() {
      // CHECK FOR MANDATORY FIELDS
      this.forceSave.next();
      const allRequirementsCompleted = await this.publicService.checkForMandatory(this.customQuestions, this.resource.customQuestions);
      if(!allRequirementsCompleted) {
        this.showMandatoryWarnings = true;
        return;
      }
      if (this.logoEditor.deleteDeletedPhotos()) {
        this.resource.logoUrl = this.logoEditor.tempThumbUrl
        this.resource.fullLogoUrl = this.logoEditor.tempUrl
      }

      this.onSubmit.emit(this.resource)
    }
}

